import { CREATE_SEARCH_DESCRIPTION_LIMIT } from 'utils/constants';
import * as yup from 'yup';

export const getBasicInformationSchema = (isCheckDescriptionEnabled: boolean) =>
  yup.object().shape({
    name: yup.string().required('Required'),
    description: yup
      .string()
      .required('Required')
      .max(CREATE_SEARCH_DESCRIPTION_LIMIT),
    hide_identity: yup.bool().required('Required'),
    check_description_status: yup.string().when('description', {
      is: (description: string) => description && isCheckDescriptionEnabled,
      then: (schema) =>
        schema.required('Please check the description to continue.'),
      otherwise: (schema) => schema.optional(),
    }),
    prompt_history_id: yup.number().optional(),
  });
